import Vue from 'vue'
import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate'
// eslint-disable-next-line
import {confirmed, email, min, required, required_if} from 'vee-validate/dist/rules'
import en from '@/locales/en.json'
import ru from '@/locales/ru.json'

extend('confirmed', confirmed)
extend('email', email)
extend('min', min)
extend('required', required)
extend('required_if', required_if)

localize({
  en: {
    messages: en.validations.messages
  },
  ru: {
    messages: ru.validations.messages
  }
})

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
